export default {
  name: 'zh-cn',
  m: {
    table: {
      menuTitle: '操作',
      preview: '预览',
    },
    dialog: {
      cancelText: '取 消',
      confirmText: '确 认',
    },
    search: {
      searchBtnText: '搜 索',
      resetBtnText: '清 空',
      expandBtn: '展 开',
      colBtn: '收 缩',
    },
    crud: {
      addBtnText: '新 增',
      editBtnText: '编辑',
      delBtnText: '删除',
      addDialogTitle: '新增',
      editDialogTitle: '编辑',
      viewDialogTitle: '查看',
      dialogSaveBtnText: '保 存',
      dialogCancelBtnText: '取 消',
    },
  },
}
